const url = "/api/v1/bookings/bookings";
import { getToken } from "./user-service";
import axios from "axios";
import { add } from "date-fns";

// used for getting all counts for the entire month for the calendar
export const getBookingsCount = async (params) => {
  const token = await getToken();

  const url =
    "/api/v1/bookings/bookingAnalytics/" +
    params.iata +
    "/counts" +
    "?date=" +
    params.date +
    `&type=${params.type || "all"}` +
    `&range=${params.range || "month"}` +
    `&byType=${params.byType || "none"}` +
    `&airline=${params.airline || ""}` +
    `&endDate=${params.endDate || ""}` +
    `&byHour=${params.byHour || ""}` +
    `&source=${params.source || "all"}` +
    `&byFlight=${params.byFlight || ""}` +
    `&forecast=${params.forecast || ""}` +
    `&reduce=${params.reduce}` +
    (params.breakdownTable ? `&breakdownTable=${params.breakdownTable}` : "") +
    `&noshows=${params.noShows == undefined ? "false" : params.noShows || "false"}`;

  // console.log('params ', params, 'url ', url)
  // if(params.type == "outbound" && params.forecast == undefined){ console.log('params ', params); }

  return new Promise(async (resolve, reject) => {
    try {
      const json = await axios.get(url, {
        headers: { "Firebase-UID": token },
      });

      if (json.status >= 400 && json.status < 600) {
        throw new Error("Bad booking details");
      }
      // if(params.type == "outbound" && params.forecast == undefined){ console.log('bookings count ', json.data); }
      resolve(json.data);
    } catch (e) {
      reject(new Error("error getting bookings"));
    }
  });
};

export const getWeeklyAnalyticsCountByHourForForecast = async (params) => {
  const token = await getToken();

  const daysArr = [0, 1, 2, 3, 4, 5, 6];
  const getUrl = (day) => {
    return (
      "/api/v1/bookings/bookingAnalytics/" +
      params.iata +
      "/counts" +
      "?date=" +
      add(new Date(params.date), { days: day }).toISOString().split("T")[0] +
      `&type=${params.type || "all"}` +
      `&range=${params.range || "month"}` +
      `&byType=${params.byType || "none"}` +
      `&airline=${params.airline || ""}` +
      `&endDate=${add(new Date(params.date), { days: day }).toISOString().split("T")[0] || ""}` +
      `&byHour=${params.byHour || ""}` +
      `&source=${params.source || "all"}` +
      `&byFlight=${params.byFlight || ""}` +
      `&forecast=${params.forecast || ""}` +
      `&reduce=${params.reduce}` +
      (params.breakdownTable
        ? `&breakdownTable=${params.breakdownTable}`
        : "") +
      `&noshows=${params.type == "inbound" || params.forecast != undefined || params.noShows == undefined ? "false" : params.noShows || "false"}`
    );
  };

  return new Promise(async (resolve, reject) => {
    const dataArr = [];

    // Use Promise.all to send all requests at once and wait for all responses
    Promise.all(
      daysArr.map((day) =>
        axios.get(getUrl(day), {
          headers: { "Firebase-UID": token },
        })
      )
    )
      .then((responses) => Promise.all(responses.map((res) => res.data)))
      .then((data) => {
        data.forEach((count, index) => {
          dataArr.push({
            analytics: count,
            day: add(new Date(params.date), { days: daysArr[index] })
              .toISOString()
              .split("T")[0],
          });
        });
        resolve(dataArr);
      })
      .catch((error) => {
        console.log(error, "getWeeklyAnalyticsCountByHourForForecast error");

        reject(error);
      });
  });
};

// used to get counts for booking forecast
export const getCounts = async (params) => {
  const token = await getToken();

  // TODO WRONG
  const url =
    "/api/v1/bookings/bookingAnalytics/" +
    params.iata +
    "/counts?date=" +
    params.startDate +
    "&type=all&range=&byType=none&airline=&endDate=" +
    params.endDate +
    "&byHour=&source=&byFlight=";

  return new Promise(async (resolve, reject) => {
    try {
      const json = await axios.get(url, {
        headers: { "Firebase-UID": token },
      });

      if (json.status >= 400 && json.status < 600) {
        throw new Error("Bad booking details");
      }
      resolve(json.data);
    } catch (e) {
      reject(new Error("error getting bookings"));
    }
  });
};

// used to get forecast notification info
export const getForecastNotifications = async (params) => {
  const token = await getToken();

  const url =
    "api/v1/bookings/bookingAnalytics/" +
    params.iata +
    "/shouldNotify?date=" +
    params.date +
    (params.carrierCode ? "&carrierCode=" + params.carrierCode : "") +
    (params.csv ? "&csv=" + params.csv : "");

  return new Promise(async (resolve, reject) => {
    try {
      const json = await axios.get(url, {
        headers: { "Firebase-UID": token },
      });

      if (json.status >= 400 && json.status < 600) {
        throw new Error("Bad booking details");
      }
      resolve(json.data);
    } catch (e) {
      reject(new Error("error getting bookings"));
    }
  });
};

// fetch the latest hourly forecast from the PRM Intelligence API
export const getHourlyForecast = async ({ iata, date }) => {
  const token = process.env.REACT_APP_INTELLIGENCE_API_TOKEN || "";

  console.log('[Forecast] Requesting: /intelligence-api/forecasts', { airport: iata, date });

  const response = await axios.get('/intelligence-api/forecasts', {
    params: { airport: iata, date },
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });

  console.log('[Forecast] Raw response:', response?.data);

  const hourly = response?.data?.forecast?.departures?.hourly;
  if (!Array.isArray(hourly) || hourly.length !== 24) {
    console.error('[Forecast] Invalid hourly shape:', hourly);
    throw new Error("Invalid hourly forecast response");
  }

  console.log('[Forecast] Hourly departures:', hourly);
  return hourly;
};

// used for getting all counts for the entire month for the calendar
export const getBookingsStats = async (params) => {
  const token = await getToken();

  const url =
    "/api/v1/bookings/bookingAnalytics/" +
    params.iata +
    "/stats" +
    "?date=" +
    params.date +
    `&range=${params.range || "month"}` +
    `&source=${params.source || "all"}` +
    `&airline=${params.airline || ""}` +
    `&endDate=${params.endDate || ""}`;

    console.log('getting booking stats', url);

  return new Promise(async (resolve, reject) => {
    try {
      const json = await axios.get(url, {
        headers: { "Firebase-UID": token },
      });

      if (json.status >= 400 && json.status < 600) {
        throw new Error("Bad booking details");
      }

      resolve(json.data);
    } catch (e) {
      reject(new Error("error getting bookings"));
    }
  });
};
